import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface ILinkLabelToAssetRouteParams {
    id: Guid
}

const LinkLabelToAssetRoute = new AppRoute<ILinkLabelToAssetRouteParams>({
    route: "/link-label/:id",
    navbar: true,
    authRequired: true,
})

export default LinkLabelToAssetRoute
